import PropTypes from 'prop-types';
import React from 'react';
import styled from 'react-emotion';
import { withRouter } from 'react-router-dom';

import { H1 } from '../../components/Text/Text';
import LoadingText from '../../components/LoadingText/LoadingText';
import Style from '../../styles/common';
import TextButton from '../../components/Buttons/TextButton';

const Container = styled('div')`
  align-items: center;
  background-color: ${Style.color.contentBackground};
  display: flex;
  justify-content: center;
  height: 100%;
`;

const Content = styled('div')`
  background-color: white;
  padding: 100px 150px;
  text-align: center;
`;

const Image = styled('img')`
  width: 80px;
`;

const Heading = styled(H1)`
  margin-top: ${Style.SPACING.XXL};
`;

const Buttons = styled('div')`
  margin-top: ${Style.SPACING.S};
`;

const StyledLoadingText = styled(LoadingText)`
  margin-top: ${Style.SPACING.XL};
`;

class StatusView extends React.Component {
  static propTypes = {
    buttonText: PropTypes.string.isRequired,
    history: PropTypes.object.isRequired,
    image: PropTypes.string.isRequired,
    loadingText: PropTypes.string.isRequired,
    navigationPath: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
  };

  componentDidMount() {
    setTimeout(() => {
      this.redirect();
    }, 5000);
  }

  render() {
    return (
      <Container>
        <Content>
          <Image src={this.props.image} />
          <Heading>{this.props.title}</Heading>
          <StyledLoadingText>{this.props.loadingText}</StyledLoadingText>
          <Buttons>
            <TextButton onClick={this.redirect}>
              {this.props.buttonText}
            </TextButton>
          </Buttons>
        </Content>
      </Container>
    );
  }

  redirect = () => {
    this.props.history.push(this.props.navigationPath);
  };
}

export default withRouter(StatusView);



// WEBPACK FOOTER //
// ./src/components/StatusView/StatusView.js